var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home_svg__clip0_4189_27909)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.27 28.28c7.809 0 14.14-6.33 14.14-14.14C50.41 6.33 44.078 0 36.27 0c-7.81 0-14.14 6.33-14.14 14.14 0 7.81 6.33 14.14 14.14 14.14z",
    fill: "url(#home_svg__paint0_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.604 50.4H0V28.364l11.802-9.33 11.802 9.33V50.4z",
    fill: "url(#home_svg__paint1_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.409 28.364H23.606V50.4h26.803V28.364z",
    fill: "url(#home_svg__paint2_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.803 19.033H39.6l10.8 9.331H23.606l-11.802-9.33z",
    fill: "url(#home_svg__paint3_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.002 32.34H1.604V50.4h20.398V32.34z",
    fill: "url(#home_svg__paint4_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.002 40.838H1.604V50.4h20.398v-9.562z",
    fill: "url(#home_svg__paint5_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.852 33.517H2.757v.51h18.095v-.51z",
    fill: "url(#home_svg__paint6_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.852 35.435H2.757v.511h18.095v-.51z",
    fill: "url(#home_svg__paint7_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.852 37.36H2.757v.511h18.095v-.51z",
    fill: "url(#home_svg__paint8_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.852 39.284H2.757v.511h18.095v-.51z",
    fill: "url(#home_svg__paint9_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.581 34.594H29.412v9.1h15.17v-9.1z",
    fill: "url(#home_svg__paint10_linear_4189_27909)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.819 17.051a1.67 1.67 0 01-1.176-.483l-3.024-2.96a1.68 1.68 0 01-.028-2.374 1.686 1.686 0 012.373-.028l1.834 1.8 4.746-4.747a1.673 1.673 0 012.373 0 1.673 1.673 0 010 2.373l-5.922 5.922c-.33.33-.756.49-1.19.49l.014.007z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint0_linear_4189_27909",
    x1: 23.123,
    y1: 4.368,
    x2: 62.218,
    y2: 33.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C47E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0BDF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint1_linear_4189_27909",
    x1: -15.659,
    y1: 34.72,
    x2: 27.649,
    y2: 34.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint2_linear_4189_27909",
    x1: 22.073,
    y1: 29.33,
    x2: 70.31,
    y2: 61.789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint3_linear_4189_27909",
    x1: 14.54,
    y1: 23.702,
    x2: 73.746,
    y2: 23.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6F6F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint4_linear_4189_27909",
    x1: 12.209,
    y1: 20.91,
    x2: 11.354,
    y2: 63.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint5_linear_4189_27909",
    x1: 11.838,
    y1: 34.09,
    x2: 11.704,
    y2: 75.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint6_linear_4189_27909",
    x1: 11.444,
    y1: 51.164,
    x2: 12.13,
    y2: 17.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint7_linear_4189_27909",
    x1: 11.479,
    y1: 51.164,
    x2: 12.172,
    y2: 17.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint8_linear_4189_27909",
    x1: 11.521,
    y1: 51.164,
    x2: 12.207,
    y2: 17.844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint9_linear_4189_27909",
    x1: 11.563,
    y1: 51.163,
    x2: 12.249,
    y2: 17.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "home_svg__paint10_linear_4189_27909",
    x1: 13.032,
    y1: 38.962,
    x2: 56.691,
    y2: 39.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#414042",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "home_svg__clip0_4189_27909"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h50.4v50.4H0z"
  })))));
}
export default SvgHome;